import Vue from "vue";
import VueRouter from "vue-router";
import { cookies } from "@/plugins/cookie";
import { clearPending } from "@/utils/request";
import { PPT_MODULE_CODES } from "@/constants/pptModules";
import AdminLayout from "@/views/admin/AdminLayout.vue";
import AdminModuleSlides from "@/views/admin/AdminModuleSlides.vue";
import CqJm from "@/views/cq_jm.vue";
import CqRt from "@/views/cq_rt.vue";
import XsqJm from "@/views/xsq_jm.vue";
import XsqJm2 from "@/views/xsq_jm2.vue";
import SjqJm from "@/views/sjq_jm.vue";
import SjqJm2 from "@/views/sjq_jm2.vue";
import RtJm from "@/views/rt_jm.vue";
import RtJm2 from "@/views/rt_jm2.vue";
import TsRb from "@/views/ts_rb.vue";
import LaeMap from "@/views/lae_map.vue";
import RobotMap from "@/views/robot_map.vue";
const NotFound = () => import("@/views/errorPage/404.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/admin/login",
    name: "adminLogin",
    component: () => import("@/views/admin/login.vue"),
    meta: { adminPublic: true }
  },
  {
    path: "/admin",
    component: AdminLayout,
    redirect: `/admin/${PPT_MODULE_CODES[0]}`,
    children: [
      {
        path: ":moduleCode",
        name: "adminPptModule",
        component: AdminModuleSlides,
        props: true
      }
    ]
  },
  {
    path: "/cq_jm",
    component: CqJm
    // beforeEnter: (to, from, next) => {
    //   const hasToken = cookies.get("token");
    //   if (hasToken) {
    //     next();
    //   } else {y
    //     next({ path: "/" });
    //   }
    // },
  },
  {
    path: "/cq_rt",
    component: CqRt
  },
  {
    path: "/xsq_jm",
    component: XsqJm
  },
  {
    path: "/xsq_jm2",
    component: XsqJm2
  },
  {
    path: "/sjq_jm",
    component: SjqJm
  },
  {
    path: "/sjq_jm2",
    component: SjqJm2
  },
  {
    path: "/rt_jm",
    component: RtJm
  },
  {
    path: "/rt_jm2",
    component: RtJm2
  },
  {
    path: "/ts_rb",
    component: TsRb
  },
  {
    path: "/lae_map",
    component: LaeMap
  },
  {
    path: "/robot_map",
    component: RobotMap
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  clearPending();
  const token = cookies.get("token");
  const isAdminLogin = to.path === "/admin/login";
  const needsAdminAuth =
    to.path.startsWith("/admin") && !isAdminLogin && !to.meta.adminPublic;

  if (needsAdminAuth && !token) {
    const q =
      to.fullPath &&
      to.fullPath.startsWith("/admin") &&
      to.fullPath !== "/admin/login"
        ? { redirect: to.fullPath }
        : {};
    next({ path: "/admin/login", query: q });
    return;
  }
  if (isAdminLogin && token) {
    next({ path: "/admin" });
    return;
  }
  next();
});

export default router;
